import { FC, memo } from "react";
import { SIDE } from "_constants";
import { StatusMessageBase } from "components/common/StatusMessageBase";
import { ICONS } from "../constants";

type Props = {
  className?: string;
  team?: string;
  side: SIDE;
  Icon?: React.ComponentType<any>;
  title?: string;
  description?: string;
  normalizedCode: string;
  status: any;
  width: number;
  height: number;
};

export const StatusMessage: FC<Props> = memo((props) => {
  const bottomCodes = ["1000", "1001", "1002", "1009", "1010"];
  const hideCode = "1003";

  const sideIconResolver = (nsc: string, side: "home" | "away") => {
    const codes = [
      "1007",
      "1008",
      "1009",
      "1010",
      "1931",
      "1932",
      "1933",
      "1934",
      "1935",
      "1936",
    ];
    if (codes.includes(nsc)) {
      return side === "home" ? ICONS["1009"] : ICONS["1010"];
    }
    return null;
  };

  return (
    <StatusMessageBase
      {...props}
      bottomCodes={bottomCodes}
      hideCode={hideCode}
      sideIconResolver={sideIconResolver}
    />
  );
});
